<template>
	<div class="sample-page">
		<div class="breadcrumb">
			<a-breadcrumb>
				<a-breadcrumb-item>
					<router-link to="/home">首页</router-link>
				</a-breadcrumb-item>
				<a-breadcrumb-item>样本管理</a-breadcrumb-item>
			</a-breadcrumb>
		</div>
		<div class="page-handle">
			<div class="left">
				<a-button v-auth="'10401'" type="primary" @click="addRetrieval">添加入库</a-button>
				<a-button v-auth="'10402'" @click="outDetrusion">出库</a-button>
				<a-button v-auth="'10403'" @click="goTerieval">入库</a-button>
			</div>
			<div class="right">
				<a-input-search placeholder="请输入样本编号" style="width: 200px" @search="onSearchKey"/>
				<a-dropdown overlayClassName="hospital-dropdown-overlay" class="hospital-dropdown-link">
					<a class="ant-dropdown-link">
						{{searchLableKey1}}
						<a-icon type="down"/>
					</a>
					<a-menu slot="overlay" style="height: 300px; overflow: hidden; overflow-y: scroll;"
					        @click="onClickSearchKey1">
						<a-menu-item key="-1">
							<a href="javascript:;">全部</a>
						</a-menu-item>
						<a-menu-item v-for="item in searchMapKey1" :key="item.deptId">
							<a href="javascript:;">{{item.deptName}}</a>
						</a-menu-item>
					</a-menu>
				</a-dropdown>
				<a-dropdown overlayClassName="hospital-dropdown-overlay" class="hospital-dropdown-link">
					<a class="ant-dropdown-link">
						{{searchLableKey2}}
						<a-icon type="down"/>
					</a>
					<a-menu slot="overlay" @click="onClickSearchKey2">
						<a-menu-item key="-1">
							<a href="javascript:;">全部</a>
						</a-menu-item>
						<a-menu-item v-for="item in searchMapKey2" :key="item.dictKey">
							<a href="javascript:;">{{item.dictValue}}</a>
						</a-menu-item>
					</a-menu>
				</a-dropdown>
			</div>
		</div>
		<div class="page-content">
			<a-table
					:pagination="false"
					:rowSelection="rowSelection"
					:columns="columns"
					:dataSource="data"
					:loading="loading"
					:rowKey="record => record.id"
					class="hospital-table"
					size="middle"
			>
				<router-link slot="hosBarCode" slot-scope="text,record" :to="{path:'/sample/detail', query:{id:record.id}}" >{{text}}</router-link>
				<template slot="scopedSampleAmount" slot-scope="text,record">
					{{toDecimal(record.sampleAmount)}}
				</template>
				<template slot="scopedOptTime" slot-scope="text,record">
					{{moment(record.optTime).format(dateFormat) }}
				</template>
			</a-table>
			<div class="pagination">
				<a-pagination
						@change="pageChange"
						:pageSize.sync="pageSize"
						v-model="page"
						size="small"
						:total="resData.total"
				/>
			</div>
		</div>
		<page-model @close="closeModel" :visible="visible">
			<retrieval v-if="visible" :list="selectRows" @close="closeModel" @clearSelected="clearSelected"></retrieval>
		</page-model>
		<page-model @close="closeModel" :visible="detrusionIsVisible">
			<detrusion v-if="detrusionIsVisible" :list="selectRows" @close="closeModel"
			           @clearSelected="clearSelected"></detrusion>
		</page-model>
		<page-model @close="closeModel" :visible="addRetrievalIsVisible">
			<add-retrieval v-if="addRetrievalIsVisible" @close="closeModel"></add-retrieval>
		</page-model>
	</div>
</template>

<script>
  import Retrieval from "./retrieval.vue";
  import Detrusion from "./detrusion.vue";
  import AddRetrieval from "./add-retrieval.vue";
  import ScrollableInkTabBar from "ant-design-vue/es/vc-tabs/src/ScrollableInkTabBar";
  import moment from 'moment';
  // 出库 只能 是在库的状态可以操作
  // 入库 只能 是待入库和出库状态可以操作
  const columns = [
    {
      title: "序号",
      customRender: (text, record, index) => `${index + 1}`
    },
    {
      title: "协作组条码",
      dataIndex: "hosBarCode",
      scopedSlots: {customRender: "hosBarCode"}
    },
    {
      title: "测序中心条码",
      dataIndex: "barCode",
      customRender: (text, record, index) => {
        if (!record.barCode) {
          return '-'
        } else {
          return record.barCode
        }
      }
    },
    {
      title: "样本编号",
      // scopedSlots: {customRender: "sampleId"},
      dataIndex: "sampleId",
      customRender: (text, record, index) => {
        if (!record.sampleId) {
          return '-'
        } else {
          return record.sampleId
        }
      }
    },
    {
      title: "样本量",
      scopedSlots: {customRender: "scopedSampleAmount"},
      dataIndex: "sampleAmount"
    },
    {
      title: "样本类型",
      dataIndex: "sampleTypeNameDict",
      customRender: (text, record, index) => {
        if (!record.sampleTypeNameDict) {
          return '-'
        } else {
          return record.sampleTypeNameDict
        }
      }
    },
    {
      title: "存储位置",
      dataIndex: "address",
      customRender: (text, record, index) => {
        if (!record.address) {
          return '-'
        } else {
          return record.address
        }
      }
    },
    {
      title: "状态",
      scopedSlots: {customRender: "operateStatusDict"},
      dataIndex: "operateStatusDict",
      customRender: (text, record, index) => {
        if (!record.operateStatusDict) {
          return '-'
        } else {
          return record.operateStatusDict
        }
      }

    },
    {
      title: "操作时间",
      scopedSlots: {customRender: "scopedOptTime"},
      dataIndex: "optTime",
      customRender: (text, record, index) => {
        if (!record.optTime) {
          return '-'
        } else {
          var time = record.optTime.replace(/(T|\.\d+)/g, ' ');
          return time;
        }
      }
    },
    {
      title: "操作人",
      dataIndex: "nickName",
      customRender: (text, record, index) => {
        if (!record.nickName) {
          return '-'
        } else {
          return record.nickName
        }
      }
    },
    {
      title: "流转机构",
      dataIndex: "deptName",
      width: '10%',
      customRender: (text, record, index) => {
        if (!record.deptName) {
          return '-'
        } else {
          return record.deptName
        }
      }
    }
  ];

  export default {
    data() {
      return {
        dateFormat: 'YYYY-MM-DD',
        data: [],
        resData: [],
        columns,
        visible: false,
        loading:false,
        detrusionIsVisible: false,
        addRetrievalIsVisible: false,
        page: 1,
        pageSize: 10,
        sampleId: '',
        selectRows: [],
        selectedRowKeys: [],
        searchKey1: '流转机构',
        searchMapKey1: [],
        searchLableKey1: '流转机构',
        searchKey2: '状态',
        searchMapKey2: [], //{1: '待入库', 2: '入库', 3: '出库', '-1': '清空'},
        searchLableKey2: '状态',
      };
    },
    components: {ScrollableInkTabBar, Retrieval, Detrusion, AddRetrieval},
    computed: {
      rowSelection() {
        const {selectedRowKeys} = this;
        return {
          selectedRowKeys,
          onChange: (selectedRowKeys, selectedRows) => {
            this.selectedRowKeys = selectedRowKeys;
            this.selectRows = selectedRows;
          },
          getCheckboxProps: record => ({
            props: {
              disabled: record.name === "Disabled User", // Column configuration not to be checked
              name: record.name
            }
          })
        };
      }
    },
    mounted() {
      this.getData();
      this.getDirt("sampleStatus").then(data => {
        this.searchMapKey2 = data.rows;
      });
      this.$get("dept/findDeptTreeList", {deptType: [1, 2, 3]}).then(
        res => {
          if (res.data.data) {
            //this.treeExpandedKeys = res.data.data.rows.children[0].children;
            let resData = res.data.data;
            for (let i = 0; i < resData.length; i++) {
              let resDataChildren = resData[i]['children'];
              for (let j = 0; j < resDataChildren.length; j++) {
                this.searchMapKey1.push(resDataChildren[j]);
              }
            }
          }
        },
        err => {
        }
      );
    },
    methods: {
      moment,
      goTerieval() {
        if (this.selectRows.length == 0) {
          this.$message.warning('请选择样本数据后入库');
        } else {
          let status = true;
          this.selectRows.forEach(item => {
            if (item.operateStatus == 2) {
              status = false;
            }
          });
          if (status) {
            this.visible = true;
          } else {
            this.$message.warning("请选择样本状态为待入库和出库数据");
          }
        }
      },
      goToDetails(record) {
        this.$router.push({
          path: "/sample/detail",
          query: {
            id: record.id
          }
        });
      },
      outDetrusion() {
        if (this.selectRows.length == 0) {
          this.$message.warning('请选择样本数据后出库');
        } else {
          let status = true;
          this.selectRows.forEach(item => {
            if (item.operateStatus == 1 || item.operateStatus == 3) {
              status = false;
            }
          });
          if (status) {
            this.detrusionIsVisible = true;
          } else {
            this.$message.warning("请选择样本状态为在库数据");
          }
        }
      },
      addRetrieval() {
        this.addRetrievalIsVisible = true;
      },
      closeModel() {
        this.visible = false;
        this.detrusionIsVisible = false;
        this.addRetrievalIsVisible = false;
        this.getData();
      },
      clearSelected() {
        this.selectedRowKeys.length = 0;
      },
      getData() {
        this.loading = true;
        this.$get("sampleinfo", {
          pageSize: this.pageSize,
          pageNum: this.page,
          deptId: this.searchKey1 === '流转机构' ? '' : this.searchKey1,
          operateStatus: this.searchKey2 === '状态' ? '' : this.searchKey2,
          sampleId: this.sampleId,
        }).then(res => {
          this.resData = res.data.data;
          this.data = this.resData.rows;
          this.loading = false
        });
      },
      onSearchKey(value) {
        this.sampleId = value;
        this.getData();
      },
      onClickSearchKey1({key}) {
        if (key == '-1') {
          this.searchKey1 = '流转机构';
          this.searchLableKey1 = '流转机构';
        } else {
          let dictValue = '';
          this.searchKey1 = key;
          this.searchMapKey1.forEach(function (item, i) {
            if (item.deptId == key) {
              dictValue = item.deptName;
              return;
            }
          })
          this.searchLableKey1 = dictValue;
        }
        this.getData();

      },
      onClickSearchKey2({key}) {
        if (key == '-1') {
          this.searchKey2 = '状态';
          this.searchLableKey2 = '状态';
        } else {
          let dictValue = '';
          this.searchKey2 = key;
          this.searchMapKey2.forEach(function (item, i) {
            if (item.dictKey == key) {
              dictValue = item.dictValue;
              return;
            }
          })
          this.searchLableKey2 = dictValue;
        }
        this.getData();
      },
      pageChange(page, pagesize) {
        this.page = page;
        this.pageSize = pagesize;
        this.getData();
      },
      getDirt(dictType) {
        return new Promise((resolve, reject) => {
          this.$get("info/commonDict", {
            dictType: dictType
          }).then(
            res => {
              resolve(res.data.data);
            },
            err => {
              reject(err);
            }
          );
        });
      },
      toDecimal(x) {
        var f = 0;
        //判断是否是字符串类型
        if (typeof(x) == "string") {
          if (x != null && x != '') {
            f = parseFloat(x);
          }
        } else {
          f = x;
        }
        f = f.toFixed(2);
        return f;
      },
    }
  };
</script>

<style lang="scss" scoped>
	.sample-page {
		width: 100%;
		min-width: 1200px;
		.page-handle {
			height: 60px;
			background: #f8fbfb;
			padding: 0 40px;
			line-height: 60px;
			border-top: 1px solid rgba(240, 242, 245, 1);
			border-bottom: 1px solid rgba(240, 242, 245, 1);
			.right {
				float: right;
				height: 60px;
				.hospital-dropdown-link {
					margin-left: 25px;
				}
				.hospital-dropdown-link {
					color: #3e7ff7;
					font-size: 12px;
				}
			}
			.left {
				height: 60px;
				float: left;
				.ant-btn + .ant-btn {
					margin-left: 5px;
				}
			}
		}
		.page-content {
			padding: 20px 40px;
			background: #fff;
			.pagination {
				margin: 20px 0;
				text-align: right;
			}
		}
	}
</style>